// react
import React, { Suspense } from "react";
import { useParams } from "react-router-dom";

// components
import Spinner from "../../../components/Spinner/ComponentLoader";

import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

// load in the legacy add-subjects flow and the refreshed flow
const LazyAddSubjects = React.lazy(() => import("./AddSubjects"));
const LazyAddSubjectsRefresh = React.lazy(() => import("./v2/AddSubjectsRefresh"));

const AddSubjectsLazyLoader = () => {
	const { cycleId = "" } = useParams();
	const { value: optionsRefreshEnabled } = useFeatureFlagQuery(
		"ff-temp-is-review-cycle-options-refresh-enabled",
		false
	);

	return (
		<Suspense fallback={<Spinner />}>
			{optionsRefreshEnabled ? <LazyAddSubjectsRefresh cycleId={cycleId} /> : <LazyAddSubjects />}
		</Suspense>
	);
};

export default AddSubjectsLazyLoader;
